<template>
  <div :class="$style.container">
    <Title is-large-title :class="$style.title" :title-params="slice.primary.partners_carousel_title" />
    <div :class="$style.logosContainer">
      <div :class="$style.banner">
        <PImage v-for="(logo, index) in slice.items" :key="`logo-${index}`" :class="$style.logo" :image-object="logo.partners_carousel_logo" />
        <PImage v-for="(logo, index) in slice.items" :key="`logo-second-${index}`" :class="$style.logo" :image-object="logo.partners_carousel_logo" />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '~/components/Title'
import PImage from '~/components/PImage'

export default {
  name: 'PartnershipCarousel',
  components: {
    Title,
    PImage,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 80px auto;
  padding: 64px 0;

  background-color: $bluko-800;

  @include below(small) {
    margin: 80px 24px 80px;
  }
}

.title {
  margin-bottom: 40px;

  color: white;
  font-weight: 200;
  font-size: 48px;
  line-height: 64px;
  text-align: center;

  @include below(small) {
    font-size: 32px;
    line-height: 48px;
  }
}

.logosContainer {
  position: relative;

  width: 100%;
  overflow: hidden;

  &::before {
    left: 0;
  }

  &::after {
    right: 0;

    transform: rotate(-180deg);
  }
}

.banner {
  display: flex;
  width: calc(260px * 28);

  overflow: hidden;

  animation: scroll 50s linear infinite;
  @include above(large) {
    margin: 40px 0;
  }
}

.logo {
  width: 180px;
  height: 32px;
  margin: 0 40px;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-260px * 14));
  }
}
</style>
